import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';

// import Cookies from 'js-cookie';

// const COOKIES_STORE_KEY = 'liphatech.confirm';

export default function bind() {}

export const displayValidationErrorModalIfNeeded = errors => {
  const title = 'Erreurs non résolues';
  const content =
    "Des erreurs sont présentes. Veuillez les résoudre pour valider l'intervetion.";

  if (errors) {
    displayValidationErrorModal(title, content);
  } else {
    return;
  }
};

function displayValidationErrorModal(title, content) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ValidationErrorModal title={title} content={content} />
  );

  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#validation-error-action-modal');

  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed

        return true;
      },
    })
    .modal('show');
}

const ValidationErrorModal = ({ title, content }) => (
  <div id="validation-error-action-modal" className="ui small modal">
    <div className="header">
      <i className="icon warning circle" />
      {title}
    </div>
    <div className="content" style={{ marginBottom: '20px' }}>
      <p>{content}</p>
    </div>
    <div className="actions">
      <div className="ui primary approve button">Retour</div>
    </div>
  </div>
);

ValidationErrorModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/validation/error-validation.js